import React, { forwardRef } from "react";

import classnames from "classnames";

import { StyledDot } from "./Styles";

export interface DotProps {
  color: string;
  size?: number;
  className?: string;
}

export const Dot = forwardRef<
  HTMLDivElement,
  DotProps & Omit<React.ComponentPropsWithoutRef<"div">, keyof DotProps>
>(({ color, size = 8, className, ...rest }, ref) => {
  return (
    <StyledDot
      className={classnames("c-dot", className)}
      ref={ref}
      $color={color}
      $size={size}
      {...rest}
    />
  );
});

Dot.displayName = "Dot";
